import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={{
          style: {
            background: "rgba(20, 18, 24, 0.92)",
            border: "1px solid rgba(255,255,255,0.08)",
            color: "rgba(255,255,255,0.92)",
            backdropFilter: "blur(12px)",
          },
        }}
      />
    </div>
  );
}

export default App;
